// removed by extract-text-webpack-plugin
module.exports = {"errorMessage":"ErrorMessage__errorMessage___1E0PW","message":"ErrorMessage__message___3LFpe","text":"ErrorMessage__text___2sIoF","image":"ErrorMessage__image___10h4n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorMessage/ErrorMessage.css
// module id = 701
// module chunks = 0